// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill' // 兼容
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import '@/assets/icons' // icon
// import '@/icons' // icon
import ElementUI from 'element-ui'
import store from './vuex/store.js'
import 'element-ui/lib/theme-chalk/index.css'
import '@/api'
import isBtn from './api/btnAuth'
import isService from './api/serviceAuth'
import caculateTime from './utils/caculateTime'
import parseTime from './utils/parseTime'
import './utils/directives.js'
import changeIdCard from '@/utils/changeIdCard.js'
import Nothing from '@/components/DefaultPage.vue'
import configUrl from './utils/config'

import {
  fetch,
  filesDownload,
  filePdf,
  uploadPhoto,
  uploadImage,
  pathUrl,
  pathUrlIsLogin,
  pathRegister
} from './utils'
import posts from './utils/post'
import VideoPlayer from 'vue-video-player'
Vue.component('Nothing', Nothing)

Vue.config.productionTip = false
require('vue-video-player/src/custom-theme.css')
require('video.js/dist/video-js.css')
// require('videojs-contrib-hls/dist/videojs-contrib-hls')

Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.use(Vuex)

Vue.prototype.$uploadImage = uploadImage
Vue.prototype.pathUrl = pathUrl
Vue.prototype.pathUrlIsLogin = pathUrlIsLogin
Vue.prototype.pathRegister = pathRegister
Vue.prototype.uploadPhoto = uploadPhoto // 图片上传地址
Vue.prototype.$ajax = fetch
Vue.prototype.postData = posts
Vue.prototype.filesDownload = filesDownload
Vue.prototype.filePdf = filePdf
Vue.prototype.$isBtn = isBtn
Vue.prototype.$isService = isService
Vue.prototype.calTime = caculateTime
Vue.prototype.parseTime = parseTime
Vue.prototype.changeIdCard = changeIdCard

router.beforeEach((to, from, next) => {
  document.getElementById('app').scrollTop = 0
  // if (sessionStorage.token === '' || sessionStorage.token === undefined) {
  //   if (to.path === '/trainClass/login') {
  //     next()
  //   } else {
  //     next('/trainClass/login') // 重定向到登录页面
  //   }
  // } else {
  //   next() // 重定向到登录页面
  // }
  // http://localhost:8000/#/activityPage/pay/72D06AD4C2AA454EA5C17813CFE73934

  // fetch.post(pathUrl('/login/isLogin')).then(res => {
  // debugger
  // fetch.post('/enterprise-service/Enterprise/checkEnterpriseNum').then(res => {
  //   if (res.code === '200') {
  //     window.location.href = 'http://192.168.1.111:5002'
  //   }
  // })
  console.log(to)

  fetch.post(pathUrlIsLogin('/user/getUserInfo')).then(res => {
  // fetch.post('http://gateway.icaoenglish.cn/admin-auth-service/user/getUserInfo').then(res => {
    if (res.code === '200') {
      store.commit('userShow', true)
      next()
    } else if (res.code === '-100') {
      store.commit('userShow', false)
      next()
      let PATH = to.fullPath.split('/').includes('FindPass')
      if (PATH || to.fullPath === configUrl.enterpriseNumber) {
        next()
      } else {
        ElementUI.Message.error('您的登录信息已经失效，请重新登录')
        next(configUrl.enterpriseNumber)
      }
    //   if (
    //     to.fullPath.indexOf('/activityPage/pay') !== -1 ||
    //     to.fullPath.indexOf('/activityPage/payNow') !== -1 ||
    //     // to.fullPath.indexOf('/payPage/balance') !== -1 ||
    //     to.fullPath.indexOf('/payPage/payNow') !== -1 ||
    //     to.fullPath.indexOf('/payPage/paySuccess') !== -1
    //   ) {
    //     sessionStorage.clear()
    //     //
    //     ElementUI.Message.error('您的登录信息已经失效，请重新登录')
    //     next('/trainClass/login')
    //   } else if (sessionStorage.token && to.path !== '/trainClass/login') {
    //     sessionStorage.clear()
    //     //
    //     ElementUI.Message.error('您的登录信息已经失效，请重新登录')
    //     next('/trainClass/login')
    //   } else if (to.path === '/Err404') {
    //     next()
    //   } else {
    //     if (
    //       to.fullPath.indexOf('null') !== -1 ||
    //       to.fullPath.indexOf('undifind') !== -1
    //     ) {
    //       next('/Err404')
    //     } else {
      //   next()
    //     }
    //   }
    } else {
      next()
    }
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js